
@if (cartElement) {
  <tw-cart-header  [cartElement]="cartElement"   [type]="cartElement._type" (click)="openPrices=!openPrices"></tw-cart-header>
}
@if (openPrices) {
  <tw-cart-detail   [cartPrices]="[price]"   [location]="cartElement.location" ></tw-cart-detail>
}